// Function to get a cookie by name
export const getCookie = (name) => {
  const cookies = document.cookie ? document.cookie.split(";") : [];
  for (let cookie of cookies) {
    const trimmedCookie = cookie.trim();
    if (!trimmedCookie.startsWith(`${name}=`)) continue;
    const cookieValue = trimmedCookie.slice(name.length + 1);
    try {
      return decodeURIComponent(cookieValue);
    } catch (error) {
      return cookieValue;
    }
  }
  return null;
};

// Function to set a cookie (session by default)
export const setCookie = (name, value, options = {}) => {
  const { days, path = "/", secure = false, sameSite = "Lax" } = options;

  let cookie = `${name}=${encodeURIComponent(value)}; path=${path}; SameSite=${sameSite}`;
  if (typeof days === "number") {
    cookie += `; max-age=${days * 24 * 60 * 60}`;
  }
  if (secure) {
    cookie += "; Secure";
  }
  document.cookie = cookie;
};

// Function to delete a cookie by name
export const deleteCookie = (name, options = {}) => {
  const { path = "/" } = options;
  document.cookie = `${name}=; path=${path}; max-age=0`;
};